export enum DSButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LINK = 'link',
}
